<template>
  <picture>
    <source :srcset="srcset" type="image/webp">
    <img :src="src" :class="classes" :fetchPriority="priority" :alt="alt" />
  </picture>
</template>

<script src="./mvt-picture.js"></script>